import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	CORRESPONDENCE_TEAM_FEATURE_KEY,
	CorrespondenceTeamState,
	CorrespondenceTeamPartialState,
	correspondenceTeamAdapter
} from './team.reducer';

// Lookup the 'CorrespondenceTeam' feature state managed by NgRx
export const getCorrespondenceTeamState = createFeatureSelector<
	CorrespondenceTeamPartialState,
	CorrespondenceTeamState
>(CORRESPONDENCE_TEAM_FEATURE_KEY);

const { selectAll, selectEntities } = correspondenceTeamAdapter.getSelectors();

export const getCorrespondenceTeamLoaded = createSelector(
	getCorrespondenceTeamState,
	(state: CorrespondenceTeamState) => state.loaded
);

export const getCorrespondenceTeamError = createSelector(
	getCorrespondenceTeamState,
	(state: CorrespondenceTeamState) => state.error
);

export const loadingCorrespondenceTeam = createSelector(
	getCorrespondenceTeamState,
	(state: CorrespondenceTeamState) => state.loaded
);

export const getAllCorrespondenceTeam = createSelector(
	getCorrespondenceTeamState,
	(state: CorrespondenceTeamState) => selectAll(state)
);

export const getCorrespondenceTeamEntities = createSelector(
	getCorrespondenceTeamState,
	(state: CorrespondenceTeamState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getCorrespondenceTeamState,
	(state: CorrespondenceTeamState) => state.selectedCorrespondenceTeamId
);

export const getSelected = createSelector(
	getCorrespondenceTeamEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
